<template>
    <div>
        <div class="app-body">
            <page-header></page-header>
            <div class="body-card yx-start">
                <!--头部信息-->
                <div class="resource-head">
                    <img :src="require('@/assets/img/orderHead.svg')" alt="">
                    <div class="resource xy-start">
                        <el-page-header @back="$router.back()" content="购买资源："></el-page-header>
                        <el-popover placement="bottom-start" popper-class="category-pp" trigger="click">
                            <div style="margin-left: 10px" slot="reference">
                                <span class="font-size18 c-2F3134 font-medium" style="font-weight:800">{{
                                        resName
                                    }}</span>
                                <button class="btn-tap"><i class="iconfont icon-qiehuan_switch-2"></i>切换科目</button>
                            </div>
                            <div class="order-category">
                                <el-cascader-panel
                                    :props="categoryProps"
                                    :options="allCategory"
                                    v-model="currentCategoryId"
                                    @change="categoryChange"
                                >
                                </el-cascader-panel>
                            </div>

                        </el-popover>

                    </div>
                </div>
                <!-- 主要内容 -->
                <div style="margin-top: 40px" class="xy-start main-content">
                    <label>主要内容：</label>
                    <div v-for="(item, index) in contentArr" :key="index" class="tag" >
                        {{ item.name }}
                    </div>
                </div>
                <!-- 购买时长 -->
                <div class="buy-plan xy-start">
                    <label>购买时长：</label>
                    <div v-for="item in times" :key="item.Id"
                         :class="{'active': item === currentTime}"
                         class="plan-item yx-between"
                         @click="currentTime = item"
                    >
                        <div class="font-size16 font-medium c-2F3134">{{ item.timeTxt }}</div>
                        <div class="price">￥{{ item.DiscountAmount }}</div>
                        <div class="ori-price font-size14">￥{{ item.Amount }}</div>
                    </div>
                </div>
                <div class="pay-methods-title font-size18 font-medium">支付方式</div>
                <!-- 支付方式 -->
                <div class="xy-start">
                    <div v-for="method in paymethods"
                         :key="method.id"
                         class="method-item xy-center jf-start"
                         @click="payId=method.id"
                         :class="{'active': payId === method.id}"
                    >
                        <div class="radio"></div>
                        <img :src="method.icon" alt=""/>
                        <span>{{ method.name }}</span>
                    </div>
                </div>
                <!-- 金额 -->
                <div class="amount-box" v-if="currentTime">
                    <div class="label c-868EA1 font-size18">
                        <label>原价：</label>
                        <label>优惠金额：</label>
                        <label>应付金额：</label>
                    </div>
                    <div class="amount font-size16">
                        <div>￥{{ currentTime.Amount }}</div>
                        <div>￥{{ calcDiscount(currentTime) }}</div>
                        <div>￥{{ currentTime.DiscountAmount }}</div>
                    </div>
                </div>
                <button class="pay-button font-size18 cursor btn-tap" @click="startPay">
                    立即支付
                </button>
            </div>
            <pay-dialog ref="payDialog" @pay-success="buySuccess" @timeout="payTimeout"></pay-dialog>

            <el-dialog v-if="currentTime"
                       title="购买须知"
                       :visible.sync="balanceDialog"
                       :destroy-on-close="true"
                       :close-on-click-modal="false"
                       width="500px">
                <div class="pay-div">
                    <label class="pay-label">购买科目：</label>
                    <span class="pay-span">{{ resName }}</span>
                </div>
                <div class="pay-div">
                    <label class="pay-label">有效时间：</label>
                    <span class="pay-span">{{ currentTime.timeTxt }}</span>
                </div>
                <div class="pay-div">
                    <label class="pay-label">消费金额：</label>
                    <span class="pay-paynumber">￥{{ currentTime.DiscountAmount }}</span>
                </div>
                <div class="pay-div">
                    <label class="pay-label">充值卡余额：</label>
                    <span class="pay-paynumber">{{ userData.Balance ? userData.Balance : "0.00" }}</span>
                </div>
                <span slot="footer" class="dialog-footer">
              <el-button size="mini" @click="balanceDialog = false">取 消</el-button>
              <el-button size="mini" type="primary" @click="balancePay">{{ balanceComfrimText }}</el-button>
            </span>
            </el-dialog>
            <el-dialog :visible.sync="waitingPay"
                       :close-on-click-modal="false"
                       width="400px"
                       :show-close="false"
                       title="支付中"
            >
                <div class="yx-center">
                    <i class="el-icon-loading" style="font-size: 50px"></i>
                    <div style="margin-top: 10px">等待支付结果中...</div>
                    <button class="cancel-order cursor btn-tap"
                        @click="waitingPay = false"
                    >取消订单</button>
                </div>
            </el-dialog>
        </div>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import PageHeader from "@/components/header";
import { aliPayPc, GetChapterPrice, PayOrderStatus, UserInfo } from "@/api/user";
import { GetColumnInfo, PurchaseProduct } from "@/api/category";
import { GetSystemCategoryInfo } from "@/api/course";
import PayDialog from "@/components/PayDialog";
import { sleep } from "@/utils";
import BottomGround from "@/components/bottomnav";

export default {
    name: "index",
    components: { PayDialog, PageHeader, BottomGround },
    data() {
        return {
            payId: "weixin",
            resName: "",
            times: [],
            contentArr: [],
            currentTime: null,
            allCategory: [],
            categoryProps: {
                value: "id",
                label: "name"
            },
            currentCategoryId: [],
            userData: {},
            balanceDialog: false,
            balanceComfrimText: "确 定",
            waitingPay: false,
            alipayOrderNo: ""
        }
    },
    computed: {
        paymethods() {
            return [
                { name: "支付宝", icon: require("@/assets/img/zhifubao.svg"), id: "alipay" },
                { name: "微信", icon: require("@/assets/img/weixin.svg"), id: "weixin" },
                { name: "充值卡", icon: require("@/assets/img/chongzhika.svg"), id: "balance" }
            ]
        }
    },
    watch: {
        waitingPay(bool) {
            if (bool === false && this.alipayOrderNo) {
                localStorage.removeItem("order_" + this.alipayOrderNo)
            }
        }
    },
    created() {
        // 获取订单详情
        const currentCategoryId = this.$route.query.columId;
        this.currentCategoryId = currentCategoryId.split(",")
        const resId = this.currentCategoryId[this.currentCategoryId.length - 1]
        this.loadInfo(resId)
        this.loadCategory()
        this.loadUserInfo()
    },
    methods: {
        async loadInfo(id) {
            // 获取价格信息
            const { data } = await GetChapterPrice({
                categoryId: id
            });
                // 获取栏目信息
            const res2 = await GetColumnInfo({
                categoryId: id
            });
            this.contentArr = res2.data.data;
            data.data.forEach(item => {
                const timeText = { 1: "一个月", 2: "三个月", 3: "六个月", 4: "一年" }
                item.timeTxt = timeText[item.ChargeTime]
            })
            this.times = data.data;
            this.currentTime = this.times[0];
            this.resName = this.currentTime.TypeName;
        },
        async loadCategory() {
            // 获取公共题库
            const res3 = await GetSystemCategoryInfo();
            this.delEmptyChildren(res3.data.data)
            this.allCategory = res3.data.data;
            this.currentCategoryId = this.reductionCategoryList(this.allCategory, this.$route.query.columId)
        },
        // 根据最后一级的id，倒推出他的父级id链，allCategory 为所有分类数组
        reductionCategoryList(allCategory, lastId) {
            function f(category) {
                if (category.children) {
                    for (const el of category.children) {
                        let id = f(el)
                        if (id) return category.id + "," + id;
                    }
                } else {
                    if (category.id === lastId) return category.id;
                }
            }
            for (const el of allCategory) {
                let id = f(el)
                if (id) return id.split(",")
            }
        },
        calcDiscount(timePlan) {
            return (timePlan.Amount - timePlan.DiscountAmount).toFixed(2)
        },
        /**
             * 删除空的children属性
             * @param children
             */
        delEmptyChildren(children) {
            children.forEach(item => {
                if (item.children.length === 0) {
                    delete item.children
                } else {
                    this.delEmptyChildren(item.children)
                }
            })
        },
        categoryChange(deeps) {
            let categroy = deeps[deeps.length - 1]
            this.loadInfo(categroy)
        },
        startPay() {
            if (this.payId === "balance") {
                this.showBalancePay()
                return;
            }
            if (this.payId === "alipay") {
                this.alipay();
                return;
            }
            this.$refs.payDialog.payOrder(this.currentTime.Id, this.payId, this.resName)
        },
        // 获取用户信息
        async loadUserInfo() {
            try {
                const { data } = await UserInfo();
                this.userData = data.data;
            } catch (err) {
                this.$toast("服务器繁忙，请稍后再试！")
            }
        },
        showBalancePay() {
            if (parseInt(this.userData.Balance) < parseInt(this.currentTime.DiscountAmount)) {
                this.balanceComfrimText = "支 付"
            } else {
                this.balanceComfrimText = "确 定"
            }
            this.balanceDialog = true;
        },
        // 余额支付
        async balancePay() {
            this.balanceDialog = false;
            if (parseInt(this.userData.Balance) < parseInt(this.currentTime.DiscountAmount)) {
                this.$confirm("当前账户余额：" + this.userData.Balance + "，小于支付金额：¥" + this.currentTime.DiscountAmount + "，是否前往充值？", "提示", {
                    confirmButtonText: "去充值",
                    cancelButtonText: "我再想想",
                    type: "warning"
                }).then(() => {
                    this.$router.push({
                        path: "/personCenter/member",
                        query: { action: "recharge" }
                    })
                }).catch(() => {
                })

                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "支付中",
                spinner: "el-icon-loading",
                background: "white"
            })
            try {
                const { data } = await PurchaseProduct({
                    productId: this.currentTime.Id
                });
                if (data.code === 100) {
                    this.$message.success("购买成功！");
                    loading.close()
                    setTimeout(this.buySuccess, 1000)
                } else {
                    this.$message(data.msg)
                }
            } catch (err) {
                this.$message("服务器繁忙，请稍后再试！");
                loading.close()
            }
        },
        // 支付宝支付
        async alipay() {
            this.waitingPay = true;
            console.log(this.currentCategoryId, "currentCategoryId")
            try {
                let href = this.$router.resolve({ 
                    name: "alipay-result",
                    query: {
                        buyQueryId: JSON.stringify(this.currentCategoryId)
                    }
                }).href;
                href = location.origin + href
                debugger
                let { data } = await aliPayPc({
                    Id: this.currentTime.Id,
                    descript: this.resName,
                    returnUrl: href
                });
                let rData = data.data;
                this.saveData(rData.orderNo)
                window.open(rData.Url, "_blank")
                // 查询支付结果
                let startT = new Date();
                const timeout = 1000 * 60 * 10; // 10分钟超时
                while (this.waitingPay) {
                    let order;
                    try {
                        order = await PayOrderStatus({
                            orderNo: rData.orderNo
                        });
                    } catch (e) {
                        console.error("查询支付状态失败,5秒后重试");
                        await sleep(5000);
                        continue
                    }
                    if (order.data.code === 100) {
                        this.waitingPay = false;
                        this.step2Success();
                    } else {
                        let useT = new Date() - startT;
                        if (useT > timeout) {
                            this.waitingPay = false;
                            this.payTimeout();
                        } else {
                            await sleep(5000);
                        }
                    }
                }
            } catch (e) {
                this.$message("服务器繁忙，请稍后再试！");
                this.waitingPay = false;
            }
        },
        /// 支付成功回调
        buySuccess() {
            this.$router.replace({
                path: "/question/public",
                query: {
                    queryId: JSON.stringify(this.currentCategoryId),
                    from: "buy"
                }
            })
        },
        step2Success() {
            this.$alert("购买成功！", "提示", {
                confirmButtonText: "确定",
                callback: action => this.buySuccess(),
                type: "success"
            })
        },
        payTimeout() {
            this.$alert("支付超时，请重新发起支付", "提示")
        },
        saveData(orderNo) {
            let data = {
                queryId: this.currentCategoryId.join(","),
                name: this.resName,
                plan: this.currentTime
            }
            window.localStorage.setItem("order_" + orderNo, JSON.stringify(data))
            this.alipayOrderNo = orderNo;
        }
    }
}
</script>

<style scoped lang="less">

.body-card {
    background: #FFFFFF;
    border-radius: 16px;
    min-height: 60vh;
    padding: 30px 30px;
    margin-top: 20px;
    font-size: 14px;
    margin-bottom: 24px;

    .resource-head {
        position: relative;

        img {
            width: 100%;
        }

        .resource {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            padding-left: 30px;
            align-items: center;

            button {
                cursor: pointer;
                padding: 2px 12px;
                margin-left: 20px;
                background: #F7FAFF;
                border-radius: 12px;
                border: 1px solid rgba(37, 108, 244, 0.6);
                color: #256CF4;

                i {
                    margin-right: 4px;
                    font-size: 14px;
                }
            }
        }
    }

    .main-content {
        label {
            margin: 0 40px 0 30px;
            line-height: 38px;
            font-size: 16px;
        }

        .tag {
            background: #FCF7E6;
            border-radius: 12px;
            border: 1px solid #EAC96A;
            line-height: 38px;
            color: #DEB34A;
            padding: 0 18px;
            margin-right: 20px;

            &:last-child {
                margin-right: unset;
            }
        }
    }

    .buy-plan {
        margin-top: 40px;

        label {
            margin: 0 40px 0 30px;
            font-size: 16px;
        }

        .plan-item {
            padding: 10px 0;
            cursor: pointer;
            width: 110px;
            height: 127px;
            background: #FFFFFF;
            border-radius: 12px;
            border: 1px solid #E5E8EC;
            margin-right: 30px;

            .price {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FF4751;
            }

            .price:first-letter {
                font-size: 14px;
            }

            .ori-price {
                text-decoration: line-through;
                color: #72777F;
            }
        }

        .plan-item.active {
            background: #FCF7E6;
            border: 1px solid #EAC96A;
        }
    }

    .pay-methods-title {
        height: 70px;
        background: #F3F5F9;
        opacity: 0.7;
        line-height: 70px;
        padding-left: 30px;
        margin-top: 60px;
        margin-bottom: 30px;
        width: 100%;
        box-sizing: border-box;
    }

    .method-item {
        width: 200px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 2px solid #E5E8EC;
        margin-right: 30px;
        font-size: 18px;
        cursor: pointer;

        .radio {
            width: 20px;
            height: 20px;
            background: #D8D8D8;
            margin-left: 30px;
            margin-right: 15px;
            border-radius: 50%;
        }

        img {
            width: 40px;
            height: 40px;
            margin-right: 20px;
        }
    }

    .method-item.active {
        border: 2px solid #256CF4;

        .radio {
            width: 20px;
            height: 20px;
            background: #FFFFFF;
            border: 5px solid #256CF4;
            box-sizing: border-box;
        }
    }

    .amount-box {
        margin: 50px 80px 0 0;
        display: flex;
        align-self: flex-end;

        .label {
            padding-right: 5px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            label {
                margin-top: 8px;
                display: block;
                line-height: 25px;
            }

            label:last-child {
                line-height: 33px;
            }
        }

        .amount {
            div {
                margin-top: 8px;
                line-height: 25px;
            }

            div:last-child {
                color: #ff4751;
                font-size: 24px;
                font-weight: 500;
                line-height: 33px;
            }
        }
    }

    .pay-button {
        width: 200px;
        height: 50px;
        line-height: 50px;
        margin: 30px 65px 0 0;
        background: #256CF4;
        border-radius: 6px;
        border: unset;
        align-self: flex-end;
        color: white;
    }
}

::v-deep .el-dialog__body {
    border-top: 1px solid #dcdfe6;
    padding: 30px 0 20px 0;
    font-size: 16px;

    .pay-div {
        height: 50px;
        line-height: 50px;

        .pay-label {
            width: 300px;
            padding-left: 100px;
            text-align: right !important;
        }

        .pay-span {
            color: black;
        }

        .pay-paynumber {
            color: red;
        }
    }

    .cancel-order {
        border: unset;
        background: #256CF4;
        color: white;
        border-radius: 3px;
        margin-top: 15px;
        padding: 5px 10px;
    }

}

::v-deep .el-dialog__footer {
    height: 50px;
    border-top: 1px solid #dcdfe6;
    margin-top: 30px;
}
</style>
<style lang="less">
.category-pp {
    border: none;
    box-shadow: none;
    background: none;

    .popper__arrow {
        display: none;
    }

    .order-category {
        background: white;
    }
}

</style>
